import {Component, inject, Inject} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MarkdownModule } from 'ngx-markdown';

export interface ReleaseNotesDialogData {
  content: string;
}

@Component({
  selector: 'app-release-notes-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, MarkdownModule],
  templateUrl: './release-notes-dialog.component.html',
  styleUrls: ['./release-notes-dialog.component.scss'],
})
export class ReleaseNotesDialogComponent {
  public dialogRef = inject(MatDialogRef<ReleaseNotesDialogComponent>);
  public data = inject(MAT_DIALOG_DATA) as ReleaseNotesDialogData;
}
